import { type ReactNode } from 'react';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogDescription,
  AlertDialogTitle,
  AlertDialogAction,
} from '~/components/ui/alert-dialog';
import type { UserProfile } from '~/types';
import { formatLastRefundTimeStamp } from '../../utils/formatLastRefundTimeStamp';

interface Props {
  userToDelete: UserProfile | null;
  willRefund: boolean;
  lastRefundTimestamp: number | null;
  onCancel: () => void;
  onUnregister: () => void;
}

export function AlertUnregister({
  userToDelete,
  willRefund,
  lastRefundTimestamp,
  onCancel,
  onUnregister,
}: Props) {
  let refundMessage: ReactNode;

  if (willRefund) {
    refundMessage = (
      <p>
        Pressing unregister will unregister {userToDelete?.firstName}{' '}
        {userToDelete?.lastName} and refund any previous payments.
      </p>
    );
  } else {
    if (lastRefundTimestamp) {
      refundMessage = (
        <>
          <p>
            Unregistering {userToDelete?.firstName} {userToDelete?.lastName}{' '}
            will cancel the registration for this event.
          </p>
          <p className="mt-2">
            <span className="font-bold">Please note:</span> No refund will be
            issued. The refund deadline was
            <br />
            <span className="font-bold text-red-500">
              {formatLastRefundTimeStamp(lastRefundTimestamp)}
            </span>
            .
          </p>
        </>
      );
    } else {
      refundMessage = (
        <p>
          Pressing unregister will unregister ${userToDelete?.firstName} $
          {userToDelete?.lastName}. Unfortunate, but{' '}
          <span className="text-bold">NO REFUND</span> will be issued.
        </p>
      );
    }
  }

  return (
    <AlertDialog open={Boolean(userToDelete)}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Are you sure you want to unregister {userToDelete?.firstName}?
          </AlertDialogTitle>
          <AlertDialogDescription>{refundMessage}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onUnregister}>
            Unregister
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
